import React, { useState, memo } from "react";
import {
  Box,
  Card,
  createStyles,
  Flex,
  Group,
  Image,
  Menu,
  Radio,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { formatCurrency } from "@/utils/common";
import IconCard from "@/assets/images/pngs/Icon_Card.png";

type SourceMock = {
  accountNo: string;
  accountName: string;
  availableBalance: number;
};

type Props = {
  title?: string;
  sourceAccount?: SourceMock[];
  // pass accountNo and availableBalance of selected source
  onChangeSourceLinkId?: (accountNo: string, availableBalance: number) => void;
};

const useStyles = createStyles(() => ({
  item: {
    "&[data-hovered]": {
      backgroundColor: "rgba(255,255,255,0.18)",
    },
  },
}));

const BeneficiaryAccounts: React.FC<Props> = ({
  title,
  sourceAccount,
  onChangeSourceLinkId,
}) => {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  const [selectedId, setSelectedId] = useState<string>(
    sourceAccount?.[0]?.accountNo || "",
  );
  const selected =
    sourceAccount?.find((s) => s.accountNo === selectedId) ||
    sourceAccount?.[0];

  const handleChange = (id: string, availableBalance: number) => {
    console.log("selected source", id, availableBalance);
    setSelectedId(id);
    onChangeSourceLinkId?.(id, availableBalance);
  };

  console.log("sourceAccount", sourceAccount);
  return (
    <Card w="100%">
      <Card.Section mt="md">
        <Group
          position="apart"
          spacing={0}
          w="100%"
          style={{ borderRadius: 8 }}
          bg="linear-gradient(89.39deg, #0058A0 -1.09%, #2A81D0 104.44%)"
        >
          <Menu width="target" position="top" withinPortal classNames={classes}>
            {/* Header hiển thị tài khoản đang chọn */}
            <Menu.Target>
              <Group
                position="apart"
                w="100%"
                sx={{ cursor: "pointer" }}
                p="md"
              >
                <Group spacing="sm">
                  <Box
                    sx={{
                      background: "#FDFDFD",
                      padding: "4px",
                      borderRadius: "50%",
                    }}
                  >
                    <Image src={IconCard} width={44} height={44} />
                  </Box>

                  <Stack spacing={2} c="white">
                    {!sourceAccount || sourceAccount.length === 0 ? (
                      <Text fz={14} c="red">
                        Không tìm thấy tài khoản thụ hưởng
                      </Text>
                    ) : (
                      <Text fz={14} c="#fff">
                        {selected?.accountNo || "Chọn tài khoản"}
                      </Text>
                    )}

                    <Text fz="sm" fw={600} c="#fff">
                      {title} {selected ? selected.accountName : ""}
                    </Text>
                  </Stack>
                </Group>
                <Group spacing="xs" c="#fff">
                  <Text c="white" fw={500}>
                    {title} {formatCurrency(selected?.availableBalance || 0)}
                  </Text>
                  <IconChevronDown
                    size="0.9rem"
                    stroke={1.5}
                    color={theme.white}
                  />
                </Group>
              </Group>
            </Menu.Target>
            {/* Dropdown list các tài khoản (giống ảnh) */}
            {sourceAccount && sourceAccount.length > 0 && (
              <Menu.Dropdown
                sx={{
                  padding: 0,
                  borderRadius: 10,
                  maxHeight: 470,
                  overflowY: "auto",
                  // background:
                  //   "linear-gradient(89.39deg, #0058A0 -1.09%, #2A81D0 104.44%)",
                  // color: "white",
                }}
              >
                {sourceAccount?.map((source) => {
                  const active = source.accountNo === selectedId;
                  return (
                    <Menu.Item
                      key={source.accountNo}
                      onClick={() =>
                        handleChange(source.accountNo, source.availableBalance)
                      }
                      sx={{
                        paddingTop: 8,
                        paddingBottom: 8,
                        borderBottom: "1px solid #EDEDED",
                      }}
                    >
                      <Flex align="center" gap={10}>
                        <Radio checked={active} />
                        <Group position="apart" w="100%">
                          <Stack spacing={2}>
                            <Text fz={14}>{source.accountNo}</Text>
                            <Text fz="sm" fw={600}>
                              {title} {source.accountName}
                            </Text>
                          </Stack>

                          <Text fz="sm" fw={500}>
                            {title} {formatCurrency(source.availableBalance)}
                          </Text>
                        </Group>
                      </Flex>
                    </Menu.Item>
                  );
                })}
              </Menu.Dropdown>
            )}
          </Menu>
        </Group>
      </Card.Section>
    </Card>
  );
};

export default memo(BeneficiaryAccounts);
